export const CaseDetailsTabs = {
  SUMMARY: 'summary',
  REVIEW: 'review',
} as const;

export type CaseDetailsTabType = (typeof CaseDetailsTabs)[keyof typeof CaseDetailsTabs];

/**
 * Workflow types whose Call Script appears ONLY while a call object exists — i.e. once
 * the Twilio callback has been received and `activeCall`/`liveCallId` is set — and goes
 * away when the call ends. This is the pre-BI-1663 behaviour, kept for these workflows
 * only; every other workflow shows the script for the whole human-call phase.
 *
 * PBM left this list in BV-2747 so its callers see the auditor's handoff notes before
 * dialing, as MedBV callers do.
 *
 * This list once had a twin, HANDOFF_ACTIONS_DISABLED_WORKFLOW_TYPES, with identical
 * membership. That gate was removed when handoff actions were enabled for every workflow
 * (LA-7378); this one governs an unrelated feature and is unaffected.
 */
const CALL_SCRIPT_LIVE_CALL_ONLY_WORKFLOW_TYPES: readonly string[] = ['transportation'];

/** True when this workflow's Call Script requires a live call to be offered. */
export const callScriptRequiresLiveCall = (workflowType?: string): boolean =>
  CALL_SCRIPT_LIVE_CALL_ONLY_WORKFLOW_TYPES.includes(workflowType ?? '');
